import type { AnalyticsObject, AnalyticsProperties } from '@core/analytics/types'

export class ComparisonPanel implements AnalyticsObject {
  name: string
  properties: AnalyticsProperties

  constructor(type: ComparisonPanelType) {
    this.name = `IMT Comparison Result ${type}`
    this.properties = {}
  }
}

export type ComparisonPanelType =
  | 'Details Panel'
  | 'Cost Breakdown'
  | 'Promotion Details'
  | 'Monito Score Breakdown'
  | 'External Fees Details'
  | 'Additional Services'
